import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Select } from "antd";
import { IteamFormModal } from "./IteamFormModal";
import { useCheckFormMultiple } from "../../../hooks/useCheckFormMultiple";
import { getStructureFormDetailsProject } from "../../../helpers/projectHelper";
import { ContainerModal } from "../../container/ContainerModal";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";

const categoriesForm = {
    categoriesAr: { name: "Ar", nameInput: "ar", nameUnite: "arC" },
    categoriesVr: { name: "Vr", nameInput: "vr", nameUnite: "arC" },
    categoriesWeb: { name: "Web", nameInput: "web", nameUnite: "arC" },
    categoriesOtro: { name: "Otro", nameInput: "otro", nameUnite: "arC" },
};

export const FormProjectDetails = ({ dataForm = {}, categories = [], platforms = [], editFormForProjectDetails, closeModalDetails }) => {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const { checkValues, onChangueValue } = useCheckFormMultiple({
        ar: dataForm.categorie["ar"].length > 0,
        vr: dataForm.categorie["vr"].length > 0,
        web: dataForm.categorie["web"].length > 0,
        otro: dataForm.categorie["otro"].length > 0,
    });

    useEffect(() => {
        form.setFieldsValue({
            description: dataForm.description,
            platforms: dataForm.platformNames,
            hardware: dataForm.properties.hardware,
            maintenance: dataForm.properties.maintenance,
            metaverso: dataForm.properties.metaverso,
            categorie: {
                ar: dataForm.categorie["ar"],
                vr: dataForm.categorie["vr"],
                web: dataForm.categorie["web"],
                otro: dataForm.categorie["otro"],
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const finishForm = async (values) => {
        setLoading(true);
        const { categorie, ...rest } = values;
        let newFormValue = {
            ...rest,
        };
        Object.entries(checkValues).forEach(([key, values]) => {
            newFormValue.categorie = {
                [key]: values ? categorie[key] : [],
                ...newFormValue.categorie,
            };
        });
        const formForEndpoint = getStructureFormDetailsProject(newFormValue, { categories: categories, platforms: platforms });

        const isCloseModal = await editFormForProjectDetails(typeForDetailsProyect.projects, formForEndpoint);

        setLoading(false);

        if (!isCloseModal) return;
        closeModalDetails();
    };

    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={"Informacion de proyecto"}
                actionButton={() => {
                    closeModalDetails();
                }}
                className={"w-[500px]"}
            >
                <Form form={form} onFinish={finishForm} className="w-full flex flex-col">
                    <IteamFormModal title="Información de proyecto">
                        <Form.Item name="description">
                            <Input.TextArea
                                className="text-[12px]"
                                placeholder="Descripción"
                                autoSize={{
                                    minRows: 5,
                                    maxRows: 5,
                                }}
                                showCount={false}
                            />
                        </Form.Item>
                    </IteamFormModal>
                    <IteamFormModal title="Plataformas">
                        <Form.Item
                            name="platforms"
                            rules={[
                                {
                                    required: true,
                                    message: "Por favor selecciona una plataforma!",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                mode="multiple"
                                placeholder="Agregar las plataforma"
                                style={{
                                    width: "100%",
                                }}
                            >
                                {platforms.map((platform) => (
                                    <Select.Option key={`${platform._id}-area`} value={platform.name}>
                                        {platform.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </IteamFormModal>
                    <IteamFormModal title="Propiedades de Proyecto">
                        <div className="w-full flex gap-4 h-[35px] ">
                            <div className="flex gap-2 text-[12px]">
                                <div className="pt-2">
                                    <p>Mantenimiento</p>
                                </div>
                                <Form.Item className=" h-full flex" name="maintenance" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                            </div>
                            <div className="flex gap-2 text-[12px]">
                                <div className="pt-2">
                                    <p>Hardware</p>
                                </div>
                                <Form.Item className=" h-full flex" name="hardware" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                            </div>
                            <div className="flex gap-2 text-[12px]">
                                <div className="pt-2">
                                    <p>Metaverso</p>
                                </div>
                                <Form.Item className=" h-full flex" name="metaverso" valuePropName="checked">
                                    <Checkbox />
                                </Form.Item>
                            </div>
                        </div>
                    </IteamFormModal>
                    <IteamFormModal title="Categorías">
                        <div className="flex flex-col gap-2 text-[12px]">
                            {Object.entries(categoriesForm).map(([key, value], index) => (
                                <div
                                    key={`${index}-data-category`}
                                    className="min-h-[60px] grid grid-cols-[40px_30px_calc(100%-40px-30px)] items-center"
                                >
                                    <p>{value.name}</p>
                                    <Checkbox
                                        checked={checkValues[value.nameInput]}
                                        onChange={(e) => {
                                            onChangueValue(value.nameInput, e.target.checked);
                                        }}
                                    />
                                    {checkValues[value.nameInput] && (
                                        <div className="h-full">
                                            <Form.Item
                                                name={["categorie", value.nameInput]}
                                                className={`h-full grid items-center ${!value && "hidden"}`}
                                                rules={[
                                                    {
                                                        required: checkValues[value.nameInput],
                                                        message: "Escoge uno por lo menos",
                                                    },
                                                ]}
                                            >
                                                <Select showSearch className="text-[12px]" mode="multiple" placeholder={`selecciona uno`}>
                                                    {Object.values(categories[key].subCategories).map((value, indexCategoria) => (
                                                        <Select.Option key={`${indexCategoria}-category-${value.nameUnite}`} value={value}>
                                                            {value}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </IteamFormModal>
                    <div className="w-full h-[40px] overflow-hidden flex justify-end gap-4">
                        <Button htmlType="button" onClick={closeModalDetails}>
                            Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
                            Guardar
                        </Button>
                    </div>
                </Form>
            </ContainerModal>
        </div>
    );
};
